import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, Clock3Icon } from 'lucide-react';
import { CtaButton, CtaTrustSignals, PaymentSeal } from './CtaButton';
import { IMAGES } from '../data/landing';
import { useOfferCountdown } from '../utils/useOfferCountdown';
const lineas = [{
  label: 'Saga completa de 4 Tomos (250 recetas)',
  valor: '$39.990'
}, {
  label: 'Regalo 1 — Tabla de Tiempos y Temp.',
  valor: '$14.900'
}, {
  label: 'Regalo 2 — Menú "Mes Resuelto"',
  valor: '$17.900'
}, {
  label: 'Regalo 3 — Carnes Baratas que saben a Lomo',
  valor: '$15.900'
}, {
  label: 'Regalo 4 — 50 Recetas Fit e Hiper-Proteicas',
  valor: '$18.900'
}, {
  label: 'Regalo 5 — Guía de Limpieza y Mantenimiento',
  valor: '$13.900'
}];
export function OfferSection() {
  const countdown = useOfferCountdown();
  return <section id="oferta-principal" className="w-full bg-[#0d1f36] py-10 text-white sm:py-16" data-id="element-160" data-mp="2t6kxq6wpo8sa">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-161" data-mp="2y5fdezzdth86">
        <div className="text-center" data-id="element-162" data-mp="12nid7lbikbth">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina con 4 tomos y 5 bonos incluidos" loading="lazy" decoding="async" fetchPriority="low" className="mx-auto mb-5 w-full max-w-md drop-shadow-2xl" data-id="element-163" data-mp="12ojyeim8ueox" />
          <h2 className="text-2xl font-black leading-tight sm:text-3xl lg:text-4xl" data-id="element-164" data-mp="sy8gtt9n06zk">Mirá todo lo que te llevás hoy</h2>
          <p className="mt-3 text-base text-slate-300" data-id="element-165" data-mp="ou0uu3ukd551">Un solo pago. Acceso de por vida. Sin suscripciones ni letra chica.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-7 rounded-3xl border border-white/10 bg-[#132c4d] p-5 sm:p-8" data-id="element-166" data-mp="1gmroq7oryhr4">
          <ul className="space-y-3" data-id="element-167" data-mp="172f58e9q186">
            {lineas.map(linea => <li key={linea.label} className="flex items-center justify-between gap-3 border-b border-white/10 pb-3 text-sm sm:text-base" data-id="element-168" data-mp="14g6t6jjzhow">
                <span className="flex items-center gap-2 text-slate-100" data-id="element-169" data-mp="3tthp8tgvj27b"><CheckIcon className="h-4 w-4 shrink-0 text-orange-400" data-id="element-170" data-mp="3trwrkuz9j358" />{linea.label}</span>
                <span className="shrink-0 text-slate-400 line-through" data-id="element-171" data-mp="2mwzdd2k20bv">{linea.valor}</span>
              </li>)}
          </ul>

          <p className="mt-5 text-right text-sm text-slate-300" data-id="element-172" data-mp="3ouwmone5g6fp">Valor total del MegaPack + bonos: <span className="font-bold text-white line-through" data-id="element-173" data-mp="3owr8e3x8w2ku">$121.490</span></p>

          <div className="mt-4 overflow-hidden rounded-2xl border border-yellow-400/30 bg-[#09182b] text-center" data-id="element-174" data-mp="3b26xyb78knew">
            <div className="bg-yellow-400 px-4 py-2 text-xs font-black uppercase tracking-widest text-[#0d1f36]" data-id="element-175" data-mp="3fwb3qr4rmpee">Oferta especial de hoy · 63% OFF</div>
            <div className="p-6" data-id="element-176" data-mp="365gjttezs1w4">
              <div className="mx-auto flex w-fit items-center gap-2 rounded-full border border-red-400/50 bg-red-500/10 px-4 py-2 text-xs font-black uppercase tracking-wide text-red-100" data-id="element-177" data-mp="364on2f9nry49">
                <Clock3Icon className="h-4 w-4 text-yellow-300" data-id="element-178" data-mp="2x37cfcf0somy" /> Termina en <span aria-live="polite" className="rounded bg-red-600 px-2 py-0.5 tabular-nums text-white" data-id="element-179" data-mp="2dhf91tgiyba6">{countdown}</span>
              </div>
              <p className="mt-5 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-180" data-mp="28kopgw5igxk0">Antes</p>
              <p className="mt-1 text-2xl font-black text-red-500 line-through sm:text-3xl" data-id="element-181" data-mp="2mjy4hshzdlme">$39.990</p>
              <p className="mt-4 text-sm font-bold uppercase tracking-widest text-slate-400" data-id="element-182" data-mp="2ij4ix5s0giwo">Hoy te llevás todo por</p>
              <p className="mt-1 text-5xl font-black text-yellow-400 sm:text-6xl" data-id="element-183" data-mp="2rhpz4ua0flua">$14.990 ARS</p>
              <p className="mt-4 inline-flex rounded-full bg-orange-600 px-4 py-2 text-sm font-black text-white" data-id="element-184" data-mp="366mg5gu1o971">RECIBÍS $81.500 EN BONOS GRATIS HOY</p>
              <p className="mt-3 text-sm text-slate-400" data-id="element-185" data-mp="318udbrrv32o2">Pago único · Equivale a un solo delivery que te llega frío.</p>
              <div className="mt-6" data-id="element-186" data-mp="3f7k8h1v4es9s"><CtaButton checkout showTrustSignals={false} data-id="element-187" data-mp="3f4y0x288ccrk" /></div>
            </div>
          </div>

          <CtaTrustSignals data-id="element-188" data-mp="3a6d2978mm158" />
          <PaymentSeal data-id="element-189" data-mp="18jjz5mpo8pvr" />
        </motion.div>
      </div>
    </section>;
}